/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPDISINVESTMENTTYPE = {
    DefinedSelectionPercent: '1',
    DefinedSelectionProportional: '2',
    DisinvestProportionatelyMoneyMarkets: '3',
    DisinvestProportionatelyAllAllowableAssets: '4',
    SpecifiedFixed: '5',
    Proportional: '6',
    SpecifiedFunds: '7',
    Combination: '8',
    FullWithdrawal: '9',
    FullTransfer: '10'
} as const;
export type IAPDISINVESTMENTTYPE = typeof IAPDISINVESTMENTTYPE[keyof typeof IAPDISINVESTMENTTYPE];


export function IAPDISINVESTMENTTYPEFromJSON(json: any): IAPDISINVESTMENTTYPE {
    return IAPDISINVESTMENTTYPEFromJSONTyped(json, false);
}

export function IAPDISINVESTMENTTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPDISINVESTMENTTYPE {
    return json as IAPDISINVESTMENTTYPE;
}

export function IAPDISINVESTMENTTYPEToJSON(value?: IAPDISINVESTMENTTYPE | null): any {
    return value as any;
}

